var _circle, _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurveyApproved(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 169,
    viewBox: "0 0 169 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 84,
    r: 63,
    fill: "#6221EA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 113.274,
    width: 126,
    height: 126,
    rx: 63,
    transform: "rotate(64.0275 113.274 0)",
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.0166,
    y: 64.168,
    width: 63.3051,
    height: 42.7119,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.969 61.4998L112.526 55.4705L106.499 45.0293H94.4418L83.9991 39L73.5564 45.0293H61.4995L55.4702 55.472L45.0293 61.4998V73.5567L39 83.9993L45.0293 94.442V106.499L55.472 112.528L61.5014 122.971H73.5582L83.9993 128.999L94.442 122.969H106.499L112.528 112.527L122.971 106.497V94.4405L129 83.9978L122.971 73.5551V61.4998H122.969ZM79.9377 102.417C79.0986 103.256 77.9932 103.664 76.8928 103.649C75.792 103.664 74.6869 103.256 73.8478 102.417L60.6871 89.2564C59.0385 87.6078 59.0385 84.9334 60.6871 83.2848L64.1711 79.8007C65.8197 78.1521 68.4942 78.1521 70.1428 79.8007L76.8928 86.5507L97.8543 65.5875C99.5029 63.9389 102.177 63.9389 103.826 65.5875L107.31 69.0716C108.959 70.7202 108.959 73.3946 107.31 75.0433L79.9377 102.417Z",
    fill: "#00C853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 64.2538,
    y1: 72.087,
    x2: 208.449,
    y2: 68.3594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9770E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6221EA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white",
    transform: "translate(39 39)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyApproved);
export default __webpack_public_path__ + "static/media/survey-approved.14b5ff960e209a429bb416c751fbf83c.svg";
export { ForwardRef as ReactComponent };